import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import './Label.scss';
import { Debounce } from '@nu-art/ts-common';
export class Label extends ComponentSync {
    labelRef = React.createRef();
    activeTooltipClass = 'tooltip-active';
    invertTooltipClass = 'invert-tooltip';
    debouncer = new Debounce(() => this.checkOverflow(), 50, 150);
    // ######################## Life Cycle ########################
    __onWindowResized() {
        this.debouncer.trigger();
    }
    deriveStateFromProps(nextProps, state) {
        state.tooltip = nextProps.tooltip ?? '';
        state.className = nextProps.className;
        state.containerSelector = nextProps.containerSelector;
        state.forceUpdate = !!nextProps.forceUpdate;
        return state;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return nextState.forceUpdate || super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    componentDidMount() {
        this.debouncer.trigger();
        this.observer.attach();
    }
    componentDidUpdate() {
        this.debouncer.trigger();
    }
    componentWillUnmount() {
        this.observer.detach();
    }
    // ######################## Logic ########################
    checkOverflow = (secondCheck = false) => {
        const el = this.labelRef.current;
        if (!el)
            return;
        const contentEl = el.children[0];
        if (!contentEl)
            return;
        const contentOverflowing = contentEl.offsetWidth < contentEl.scrollWidth;
        if (contentOverflowing) { //Currently truncated
            el.classList.add(this.activeTooltipClass);
        }
        else { //Currently not truncated
            el.classList.remove(this.activeTooltipClass);
            if (!secondCheck)
                this.checkOverflow(true);
        }
    };
    checkTooltipDir = () => {
        const el = this.labelRef.current;
        if (!el || !this.state.containerSelector)
            return;
        const container = el.closest(this.state.containerSelector);
        if (!container)
            return;
        const containerTop = container.getBoundingClientRect().top;
        const labelRect = el.getBoundingClientRect();
        const distance = labelRect.top - containerTop;
        //Should be inverted
        if (distance <= labelRect.height * 2.5) {
            if (!el.classList.contains(this.invertTooltipClass))
                el.classList.add(this.invertTooltipClass);
        }
        else { //Should not be inverted
            if (el.classList.contains(this.invertTooltipClass))
                el.classList.remove(this.invertTooltipClass);
        }
    };
    getProps = () => {
        const { tooltip, className, containerSelector, onClick, forceUpdate, ...rest } = this.props;
        return {
            ...rest,
            className: _className('ts-label', className),
            'data-tooltip': this.state.tooltip,
            onMouseEnter: this.checkTooltipDir,
            onClick,
            ref: this.labelRef,
        };
    };
    observer = {
        observer: new ResizeObserver(() => this.checkOverflow()),
        attach: () => {
            const el = this.labelRef.current;
            if (!el)
                return;
            this.observer.observer.observe(el);
        },
        detach: () => this.observer.observer.disconnect(),
    };
    // ######################## Render ########################
    render() {
        return _jsx("div", { ...this.getProps(), children: _jsx("div", { className: 'ts-label__content', children: this.props.children }) });
    }
}
//# sourceMappingURL=Label.js.map